<script>
// Mixins
import styles from '../mixins/styles.js';

// Types
import { 
    typographyVariants, 
    defaultTypoVariant,
    typographySizes,
    defaultTypoSize,
    typographyColors,
    defaultTypoColor,
    typographyWeights,
    defaultTypoWeight,
    typographyTransform,
    defaultTypoTransform
} from '../types/Typography.types';

// Utils
import { eligibleProp } from '../utils/props-utils';

export default {
    name: 'Typography',
    mixins: [styles],
    props: {
        variant: {
            type: String,
            default: defaultTypoVariant,
            validator: eligibleProp(typographyVariants)
        },
        size: {
            type: String,
            default: defaultTypoSize,
            validator: eligibleProp(typographySizes)
        },
        color: {
            type: String,
            default: defaultTypoColor,
            validator: eligibleProp(typographyColors)
        },
        weight: {
            type: String,
            default: defaultTypoWeight,
            validator: eligibleProp(typographyWeights)
        },
        transform: {
            type: String,
            default: defaultTypoTransform,
            validator: eligibleProp(typographyTransform)
        }
    },
    computed: {
        typographyClasses: function () {
            return [
                this.cssClasses.pcc__typo,
                this.size && this.cssClasses[`pcc__typo_${this.size}`],
                this.cssClasses[`pcc__typo_${this.color}Color`],
                this.cssClasses[`pcc__typo_${this.weight}Weight`],
                this.cssClasses[`pcc__typo_${this.transform}Transform`],
            ];
        }
    },
    render: function (createTypo) {
        return createTypo(this.variant, { class: this.typographyClasses }, this.$slots.default);
    }
}
</script>
